import React from "react";
import Image from "gatsby-image/withIEPolyfill";

import { PrismicColor } from "utils";

import { Box, Wrapper } from "components";

function FullWidthImage({ image, background, width }) {
  if (image && image.fluid)
    return (
      <Wrapper
        py={{ _: "layout.5", md: "layout.6" }}
        bg={PrismicColor(background)}
      >
        <Box
          width={{
            _: 1 / 1,
            lg: width === "2/3" ? 2 / 3 : "1/2" ? 1 / 2 : 1 / 1,
          }}
          mx="auto"
        >
          <Image fluid={image.fluid} alt={image.alt} />
        </Box>
      </Wrapper>
    );
  else return null;
}

export default FullWidthImage;
